import { Routes } from '@angular/router';
import { EmailVerificationPageComponent } from './features/auth/email-verification-page.component';
import { PasswordResetPageComponent } from './features/auth/password-reset-page.component';
import { AppRedirectPageComponent } from './features/home/app-redirect-page.component';
import { LandingPageComponent } from './features/home/landing-page.component';
import { PublicLayoutComponent } from './features/layout/public-layout.component';
import { PrivacyPolicyPageComponent } from './features/legal/privacy-policy-page.component';
import { DataDeletionPageComponent } from './features/legal/data-deletion-page.component';

export const routes: Routes = [
  { path: 'reset-password', component: PasswordResetPageComponent },
  { path: 'verify-email', component: EmailVerificationPageComponent },
  { path: 'open-app/auth', component: AppRedirectPageComponent, data: { itemKind: 'auth' } },
  { path: 'open-app/recipe/:id', component: AppRedirectPageComponent, data: { itemKind: 'recipe' } },
  { path: 'open-app/profile/:id', component: AppRedirectPageComponent, data: { itemKind: 'profile' } },
  { path: 'recipe/:id', component: AppRedirectPageComponent, data: { itemKind: 'recipe' } },
  { path: 'recipes/:id', component: AppRedirectPageComponent, data: { itemKind: 'recipe' } },
  { path: 'member/:id', component: AppRedirectPageComponent, data: { itemKind: 'profile' } },
  { path: 'members/:id', component: AppRedirectPageComponent, data: { itemKind: 'profile' } },
  { path: 'profile/:id', component: AppRedirectPageComponent, data: { itemKind: 'profile' } },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: LandingPageComponent },
      { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
      { path: 'data-deletion-request', component: DataDeletionPageComponent },
    ],
  },
  { path: '**', redirectTo: '' },
];
